/**
 * ajax内部调用Dajax方法,
 * Dajax已支持安全签名
 * @param obj
 */

import { isObj } from './lang'
import Dajax from '@didi/dajax'

export function ajax (obj) {
  if (!isObj(obj)) {
    return
  }
  let _method = obj.method
  let _url = obj.url

  // method 参数增加默认值 并兼容字母大写的情况
  _method = _method ? _method.toLowerCase() : 'get'

  // 设置默认请求参数
  let config = {
    url: _url,
    method: _method,
    needEncrypt: obj.needEncrypt || false,
    dataType: obj.dataType
  }

  /**
   * 判断请求header 并设置 emulateJSON参数
   * true->application/x-www-form-urlencoded形式提交
   * 默认传 application/json
   * 底层axios默认使用 application/json
   */
  if (!(obj.headers && (obj.headers['Content-Type'] || '').indexOf('application/json') !== -1)) {
    config = Object.assign(config, {emulateJSON: true})
  }

  const _data = obj.data
  switch (config.method) {
  case 'get':
    config.params = _data
    break
  case 'jsonp':
    config.params = _data
    // 请求时的回调参数key，默认值为callback
    if (obj.jsonp) {
      config = Object.assign(config, {jsonp: obj.jsonp})
    }
    // jsonp方法去掉链接中callback=?字符串 原ajax方法在调用时会传callback=?
    if (_url.indexOf('callback=?') !== -1) {
      config.url = _url.replace('callback=?', '')
    }
    break
  case 'post':
  case 'put':
  case 'delete':
  case 'patch':
  default:
    config.data = _data
    break
  }
  requestMethod(config, obj)
}

/**
 * 调用Dajax 请求方法
 * 并执行成功或失败的回调方法
 */
function requestMethod (config, obj) {
  console.log(config)
  Dajax.request(config)
    .then((response) => {
      obj.success && obj.success(response.data)
    })
    .catch((err) => {
      config.error && config.error(err)
    })
}
